"use strict";

exports.isTokenValid = exports.floatPrecision = void 0;
var _jwtDecode = require("jwt-decode");
/**
 * Check if a JWT token is valid.
 * Tries to Decode the token and checks if the `exp` field is present.
 * It then checks if the current time is before the `exp` time.
 *
 * @param {string} token - The JWT token to be checked.
 * @return {boolean} `true` if the token is valid, `false` otherwise.
 */
const isTokenValid = token => {
  try {
    const decodedToken = _jwtDecode(token);
    if (!decodedToken || !decodedToken.exp) return false;
    const currentTime = new Date().getTime() / 1000;
    return decodedToken.exp > currentTime;
  } catch (error) {
    return false;
  }
};
exports.isTokenValid = isTokenValid;
const floatPrecision = function (equation) {
  let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
  return Math.ceil(equation * 10 ** precision) / 10 ** precision;
};
exports.floatPrecision = floatPrecision;